import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { skeletonVariants } from './skeleton.variants';

export interface SkeletonProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof skeletonVariants> {}

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, shape, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn(skeletonVariants({ shape }), className)}
      {...props}
    />
  ),
);

Skeleton.displayName = 'Skeleton';
